import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { Role } from "@packsize/identity-api-sdk";
import { useIdentityClient } from "@packsize/authentication";

import { COMPANY_ROLES_QUERY_KEY, ROLES_QUERY_KEY } from "@/hooks/roles/use-roles";

export const useCreateRole = () => {
	const { client } = useIdentityClient();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (role: Role) => client.addRole(role),
		onSuccess: (result) => {
			if (result.success) {
				void queryClient.invalidateQueries({ queryKey: [ROLES_QUERY_KEY] });
				void queryClient.invalidateQueries({ queryKey: [COMPANY_ROLES_QUERY_KEY] });
			}
		},
	});
};
